import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "landing-page__addOffer",
  class: "thanks"
}
const _hoisted_2 = {
  id: "body",
  class: "fullwidth"
}
const _hoisted_3 = {
  class: "page-header",
  style: {"text-align":"center"}
}
const _hoisted_4 = { class: "width-wrap" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "content-thanks" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "buttons buttons-inline" }
const _hoisted_11 = ["href", "onClick"]
const _hoisted_12 = { class: "page-content" }
const _hoisted_13 = { class: "width-wrap" }
const _hoisted_14 = { class: "page-content__header" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  class: "columns is-2 is-vertical-centered",
  id: "content-1"
}
const _hoisted_17 = { class: "column" }
const _hoisted_18 = { class: "column" }
const _hoisted_19 = {
  key: 0,
  class: "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_ShareNetwork = _resolveComponent("ShareNetwork")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: { name: 'AdSearch' },
            custom: ""
          }, {
            default: _withCtx(({ href }) => [
              _createElementVNode("a", {
                href: href,
                id: "header-logo",
                style: {"display":"inline-block"}
              }, [
                _createElementVNode("img", {
                  src: _ctx.logoUrl,
                  width: "270",
                  height: "47",
                  alt: _ctx.domain + ' logo'
                }, null, 8, _hoisted_6)
              ], 8, _hoisted_5)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ResizableImage, {
              url: "/img/balloons.webp",
              width: 1104,
              height: 659,
              alt: "Balloons"
            }),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h1", {
                innerHTML: _ctx.$t('AdThankYou.title')
              }, null, 8, _hoisted_9),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "button button--secondary is-size-medium",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToShare && _ctx.scrollToShare(...args)))
                }, _toDisplayString(_ctx.$t('AdThankYou.button-chance')), 1),
                _createVNode(_component_router_link, {
                  to: { name: 'AdUserList' },
                  custom: ""
                }, {
                  default: _withCtx(({ href, navigate }) => [
                    _createElementVNode("button", {
                      href: href,
                      onClick: navigate,
                      class: "button button--primary is-size-medium"
                    }, _toDisplayString(_ctx.$t('AdThankYou.button-ads')), 9, _hoisted_11)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h2", {
              innerHTML: _ctx.$t('AdThankYou.subtitle')
            }, null, 8, _hoisted_15)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_ResizableImage, {
                url: "/img/monitor-dell.webp",
                width: 464,
                height: 237,
                alt: "Monitor Dell"
              })
            ]),
            _createElementVNode("div", _hoisted_18, [
              (_ctx.ad)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('AdThankYou.increase-chance')), 1),
                    _createVNode(_component_ShareNetwork, {
                      url: _ctx.url,
                      title: _ctx.ad.title,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.share())),
                      class: "button button--primary is-size-medium button--facebook",
                      network: "facebook"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('AdThankYou.button-share')), 1)
                      ]),
                      _: 1
                    }, 8, ["url", "title"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}